import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getOrderGeneratorsFieldsWorksExecutorsBrigades(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES,
		options
	)
}

function _getOrderGeneratorsFieldsWorksExecutorsBrigade(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE,
		options
	)
}

function _createOrderGeneratorsFieldsWorksExecutorsBrigade(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE,
		options
	)
}

function _putOrderGeneratorsFieldsWorksExecutorsBrigade(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].PUT_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE,
		options
	)
}

function _patchOrderGeneratorsFieldsWorksExecutorsBrigade(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].PATCH_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE,
		options
	)
}

function _deleteOrderGeneratorsFieldsWorksExecutorsBrigade(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].DELETE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES]: _getOrderGeneratorsFieldsWorksExecutorsBrigades,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE]: _getOrderGeneratorsFieldsWorksExecutorsBrigade,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE]: _createOrderGeneratorsFieldsWorksExecutorsBrigade,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].PUT_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE]: _putOrderGeneratorsFieldsWorksExecutorsBrigade,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].PATCH_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE]: _patchOrderGeneratorsFieldsWorksExecutorsBrigade,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].DELETE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE]: _deleteOrderGeneratorsFieldsWorksExecutorsBrigade,
}